export default {"src":"/_next/static/media/BBWI.3c85bc13.svg","height":18,"width":18};